import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";

const TRANSACTIONS_QUERY = gql`
  query GetBuyData($portfolioId: Long) {
    portfolio(id: $portfolioId) {
      id
      accounts {
        id
        name
        number
        cashAccount
        currency {
          securityCode
        }
        tags
        portfolio {
          portfolioReport(
            adjustPositionsBasedOnOpenTradeOrders: false
            calculateExpectedAmountBasedOpenTradeOrders: true
          ) {
            portfolioId
            accountBalanceAdjustedWithOpenTradeOrders: accountBalance
          }
        }
      }
      currency {
        securityCode
      }
      portfolioReport(
        adjustPositionsBasedOnOpenTradeOrders: true
        calculateExpectedAmountBasedOpenTradeOrders: true
      ) {
        portfolioId
        accountBalanceAdjustedWithOpenTradeOrders: accountBalance
        accountItems {
          account {
            id
            name
            number
            cashAccount
            currency {
              securityCode
            }
            tags
          }
          balance
          balanceAccCurr
          amountFromOpenTradeOrders
          amountAfterOpenTradeOrders
        }
      }
    }
  }
`;

export interface BankAccount {
  id: number;
  name: string;
  number: string;
  cashAccount: boolean;
  currency: {
    securityCode: string}
  tags: string;
  portfolio: {
    portfolioReport:{
      accountBalanceAdjustedWithOpenTradeOrders: number;
    }
  }
  balanceAccCurr?: number;
  amountFromOpenTradeOrders?: number;
  amountAfterOpenTradeOrders?: number;
}

export interface BankAdjustedBalances {
  account: {
  id: number;
  name: string;
  number: string;
  cashAccount: boolean;
  currency: {
    securityCode: string}
  tags: string;
  }
  balance: number;
  balanceAccCurr?: number;
  amountFromOpenTradeOrders: number;
  amountAfterOpenTradeOrders: number;
}

interface PortfolioTransactionsQuery {
  portfolio: {
    accounts: BankAccount[],
    currency: {
      securityCode: string;
    };
    portfolioReport: {
      accountBalanceAdjustedWithOpenTradeOrders: number;
      accountItems: BankAdjustedBalances[];
    };
  };
}

export const useGetBuyData = (portfolioId: number | undefined) => {
  const { loading, error, data } = useQuery<PortfolioTransactionsQuery>(
    TRANSACTIONS_QUERY,
    {
      variables: {
        portfolioId,
      },
      ...getFetchPolicyOptions(`useGetBuyData.${portfolioId}`),
    }
  );

  const bankAll : BankAccount[] | undefined = data?.portfolio?.accounts

  const bankAvailable = data?.portfolio?.portfolioReport?.accountItems 

    const bankAvailableDown = bankAvailable?.map((bankAccount=> {
    return {
      id: bankAccount.account.id,
      name: bankAccount.account.name,
      number: bankAccount.account.number,
      cashAccount: bankAccount.account.cashAccount,
      currency: bankAccount.account.currency,
      tags: bankAccount.account.tags,
      ...bankAccount
    }
  }))

  const bankMerged = bankAll?.map((account)=>({
    ...account,
    balanceAccCurr: bankAvailableDown?.find((element) => element.id === account.id)?.balanceAccCurr || 0,
    amountAfterOpenTradeOrders: bankAvailableDown?.find((element) => element.id === account.id)?.balance || 0,
    amountFromOpenTradeOrders: bankAvailableDown?.find((element) => element.id === account.id)?.amountFromOpenTradeOrders || 0

  }))


  return {
    loading,
    error,
    data: data && {
      availableCash:
        data.portfolio?.portfolioReport
          ?.accountBalanceAdjustedWithOpenTradeOrders,
      currency: data.portfolio?.currency?.securityCode,
      bankAccounts: data.portfolio?.accounts,
      accountBalances: data.portfolio?.portfolioReport?.accountItems,
      bankMerged: bankMerged
    },
  };
};


